import { Injectable } from '@angular/core';
import * as AWS from 'aws-sdk/global';
import * as S3 from 'aws-sdk/clients/s3';
import {AuthorisationDetails} from '../core/AuthorisationDetails';
import {CustomAuthService} from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  private bucket = new S3({
     accessKeyId: 'AKIAYEEF45HRCWH4HDEB',
     secretAccessKey: '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',
     region: 'eu-west-2'
  });
  private savedFiles = [];
  private petFileData = [];
  private authDetails: AuthorisationDetails = this.authService.authDetails;
  constructor(private authService: CustomAuthService) { }

  saveFiles(files) {
      this.savedFiles = files;
      console.log('save files', this.savedFiles);
  }

  uploadFile(petId) {
      const files = this.savedFiles;
      console.log('files', files, 'petId : ', petId)
      this.authDetails = this.authService.authDetails;
      const folder = 'customers/' + this.authDetails.customerSid + '/' + petId + '/';
      const ResponseData = [];
     /* const bucket = new S3(
          {
              accessKeyId: 'AKIAYEEF45HRCWH4HDEB',
              secretAccessKey: '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',
              region: 'eu-west-2'
          }
      );*/
      for (let i = 0; i < files.length; i++) {
          const params = {
              Bucket: 'bookapen-public-doc',
              Key: folder + files[i].name,
              Body: files[i],
              ACL: 'public-read',
              ContentType: files[i].type
          };
          this.bucket.upload(params, function (err, data) {
              if (err) {
                  console.log('There was an error uploading your file: ', err);
              } else {
                  ResponseData.push(data);
                  if (ResponseData.length === files.length) {
                      console.log('Successfully uploaded file.', ResponseData);
                  }
              }
          });
      }
  }

  getFile(petId, callback) {
      this.authDetails = this.authService.authDetails;
      const folder = 'customers/' + this.authDetails.customerSid + '/' + petId + '/';
      const params = {
          Bucket: 'bookapen-public-doc',
          Prefix: folder
      };
      this.bucket.listObjects(params, callback);
  }

  deleteFile(fileKey) {
      const params = {
          Bucket: 'bookapen-public-doc',
          Key: fileKey
      };
      this.bucket.deleteObject(params, function (err, data) {
          if (err) {
              console.log('There was an error deleting your file: ', err.message);
              return;
          }
          console.log('Successfully deleted file.');
      });
  }
}
